import React, { useState, useEffect, useRef } from "react";
import { API_URL, FOLDERPATH } from "../Constants/config";
import axios from "axios";
import { Link } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CandidateTab from "./CandidateTab";
import NotificationPanels from "./NotificationPanels";
import PersonalDetailsIcon from "../assets/img/personal-details-icon.png";
import "../assets/css/candidate-tab-form.css";
import "../assets/css/inner-tabs.css";
import TickIconBlack from "../assets/img/tick-icon-black.png";
import CrossIcon from "../assets/img/cross-icon.png";
import { toast } from "react-toastify";
import UploadIcon from "../assets/img/upload-icon.svg";
import ArrowRightIcon from "../assets/img/arrow-right-icon.png";
import CalendarIcon from "../assets/img/calendar-icon.svg";
import BagIcon from "../assets/img/bag-icon.svg";
import CallIcon from "../assets/img/call-icon.png";
import EmailIcon from "../assets/img/email-icon.png";
import { useDispatch, useSelector } from "react-redux";
import { creditExperianHistory, sendOTPExperianHistory, getPincode, deletePincodeDetails, deleteMatchOTPDetails, deleteOTPExperianDetails, validateExperianOtp, saveExperianHistory, deleteSaveExperianDetails, deleteCreditExperianHistory } from "../Actions/creditExperianHistoryAction";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import ABYear from './Common/ABYear';
import ABUpload from './Common/ABUpload';
import ABText1 from './Common/ABText1';
import ABCarousel from './ABCarousel';
import ABSelect from './Common/ABSelect';
import GetMasterData from "./../Helper/masterData";
import InputField from "./InputField";
import Footer from './Footer.js';
import StepCount from "./Common/StepCount";
import {
  validateEmail,
  validateMobileNumber,
  validateAlphabetsAndSpace,
  validatePincode,
  validateNumeric,
  validatePAN
} from "../Helper/common";
import Loader from "./Common/loader";
import GreenTickBigIcon from "../assets/img/tick-green-big-icon.svg";
import MobileIcon from "../assets/img/mobile-icon.svg";
import "../assets/css/otp-box.css";
import $ from "jquery";
import ClientSideBar from "./Partials/ClientSideBar";
import ClientHeader from "./Partials/ClientHeader";
import DynamicModal from "./DynamicModal/DynamicModal.jsx";
import modalContent3Icon from "../assets/img/exclamation-mark-icon.svg";
import VerifyViaPhoneNo from "./CreditHistory/VerifyViaPhoneNo.jsx";
import AnsBelowQues from "./CreditHistory/AnsBelowQues.jsx";
import DetailsNotFound from "./CreditHistory/DetailsNotFound.jsx";
import VerifyViaOTP from "./CreditHistory/VerifyViaOTP.jsx";
import ProgressHeading from "./Common/ProgressHeading.jsx";


const CandidateCreditExperianHistory = () => {
  const navigate = useNavigate();
  const form = useRef();
  const [timer, setTimer] = useState(40);
  const [skiptimer, setSkiptimer] = useState(10);
  const [creditBureau, setCreditBureau] = useState();
  const [IsEquafixEnabled, setIsEquafixEnabled] = useState();
  const [toggle, setToggle] = useState(false);
  const [count,setCount]=useState(1);
  const [url, setUrl] = useState({});
  const [newRecord, setNewRecord] = useState({});
  const [newRecord1, setNewRecord1] = useState({});
  const [gender, setGender] = useState({});
  const [flag, setFlag]= useState(0);
  const [skipDisabled, setSkipDisabled]= useState('disabled');
  const [consentFlag, setConsentFlag]= useState(0);
  const [consentUrl, setConsentUrl] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [creditData, setCreditHistoryData] = useState({});
  const [companyName, setCompanyName] = useState('');
  const [showProfilePreview, setShowProfilePreview] = useState(0);
  const [referenceData1, setPersonalReferenceData1] = useState({});
  const [CreditHistoryCompleted, setCreditHistoryCompleted] = useState(false);
  const [errorData, setErrorData] = useState({});
  const storeData = useSelector((state) => state.creditExperian);
  const [newValidationRecord, setNewValidationRecord] = useState({});
  const storeData2 = useSelector((state) => state.saveCreditExperian);
  const [otpMatch, setOtpMatch]= useState({});
  const storeOtpMatch = useSelector((state) => state.otpMatch);
  const { otpMatchExperianData, loading: otpLoading, error: otpError } = storeOtpMatch;
  const [showModal3, setShowModal3] = useState(false);
  const [isVerifyViaPhoneNoVisible, setIsVerifyViaPhoneNoVisible] = useState(false);
  const [isQuestionVisible, setIsQuestionVisible] = useState(false);
  const [detailsNotfoundFlag, setDetailsNotfoundFlag] = useState(false);
  const [otpSentOnMatchFlag, setOtpSentOnMatchFlag] = useState(false);
  const [selectedAltNumber, setSelectedAltNumber] = useState('');

  let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
  let clientId;

  if(user && (user?.client_id || user?.bridge_client_id)){
    clientId = user?.client_id || user?.bridge_client_id;  
  }
  
  useEffect(() => {
    if (typeof otpLoading !== "undefined" && otpLoading !== null) {
      if (otpLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [otpLoading]);
  const storeData3 = useSelector((state) => state.saveExperian);
  const dispatch = useDispatch();
  const [reference,setReference]=useState();
  const [tokenId,setToken]=useState();
  const [role,setRole]=useState();
  useEffect(()=>{
    let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
   setReference(list.reference_number);
   setToken(list.id);
   if (typeof list.consent_complete !== "undefined" && list.consent_complete !== null) {
        setConsentFlag(list.consent_complete);
      }
      
  },[]);
  const { creditExperianData, loading: getLoading, error: getError} = storeData;

  useEffect(()=>{
    let IsEquafixEnabled = creditExperianData?.data?.is_equafix_enabled
    let credit_bureau = creditExperianData?.data?.CREDIT_BUREAU
    setIsEquafixEnabled(IsEquafixEnabled)
    setCreditBureau(credit_bureau)
  },[creditExperianData])

  useEffect(()=>{
    if(IsEquafixEnabled=='1' && creditBureau=='Equafix'){
      //setConsentFlag(1);
    }
  },[IsEquafixEnabled, creditBureau])
  useEffect(() => {
    if (typeof getLoading !== "undefined" && getLoading !== null) {
      if (getLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [getLoading]);

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  const { saveCreditExperianData, loading: saveLoading, error: saveError} = storeData2;
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [saveLoading]);
  const { saveExperianData, loading: saveLoading1, error: saveError1} = storeData3;
  useEffect(() => {
    if (typeof saveLoading1 !== "undefined" && saveLoading1 !== null) {
      if (saveLoading1 === true) {
        setIsLoading(true);
      } else { setIsLoading(false); }

    }
  }, [saveLoading1]);

  useEffect(() => {
    // debugger;
    if (typeof saveExperianData.data !== "undefined" && saveExperianData.data !== null) {
      const group = saveExperianData.data.group ? saveExperianData.data.group.group_id : '';
      if (group == 'profile_preview') {
      navigate(
        `/case-initiation/profile-preview/${reference}`
      );
      dispatch(deleteSaveExperianDetails());
      } else if (typeof group != "undefined" && group != '') {
      navigate(
        `/case-initiation/check-detail/${reference}/${group}`
      );  
      dispatch(deleteSaveExperianDetails());
      }
   }
  }, [saveExperianData, storeData3]);

  const [formError, setFormError] = useState({});
  const [formVal, setFormVal] = useState({});
  
  useEffect(() => {
    // debugger
    if (typeof creditExperianData.data !== "undefined" && creditExperianData.data !== null) {
      let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
      const group = creditExperianData.data.group ? creditExperianData.data.group.group_id : '';
      if (group == 'profile_preview') {
      navigate(
        `/case-initiation/profile-preview/${list.reference_number}`
      );
      dispatch(deleteCreditExperianHistory());
      } else if (typeof group != "undefined" && group != '') {
      navigate(
        `/case-initiation/check-detail/${list.reference_number}/${group}`
      );
      dispatch(deleteCreditExperianHistory());  
      } else {
        setCreditHistoryData(creditExperianData.data['fields']);
        setCreditHistoryCompleted(creditExperianData.data['candidates'].credit_history_check_completed);
        setGender(creditExperianData.data['gender']);
        setCompanyName(creditExperianData.data['company_name']);
        setShowProfilePreview(creditExperianData.data['showProfilePreview']);
        setConsentUrl(creditExperianData.data['consent_url_experian']);
        if (creditExperianData.data['CREDIT_BUREAU'] == 'CIBIL') {
          let list = JSON.parse(localStorage.getItem('userVerificationCandidate'));
          setUrl(`/case-initiation/check-detail/${list.reference_number}/8/cibil`);
          navigate(
          `/case-initiation/check-detail/${list.reference_number}/8/cibil`
          ); 
        } else {
          setUrl(`/case-initiation/check-detail/${list.reference_number}/8`);
        }
      }
    }
  }, [creditExperianData, storeData]);
  
  useEffect(() => {
    // debugger
    const fetchData = async () => {
      dispatch(creditExperianHistory());
    };
    fetchData();
  }, []);
  
  useEffect(() => {
    //debugger;
    if (typeof saveCreditExperianData !== "undefined" && saveCreditExperianData !== null) {
      const group = saveCreditExperianData?.data?.group ? saveCreditExperianData?.data?.group.group_id : '';
      if (group == 'profile_preview') {
      navigate(
        `/case-initiation/profile-preview/${reference}`
      );
      dispatch(deleteOTPExperianDetails());
      dispatch(deleteCreditExperianHistory());
      } else if (typeof group != "undefined" && group != '') {
      navigate(
        `/case-initiation/check-detail/${reference}/${group}`
      );  
      dispatch(deleteOTPExperianDetails());
      dispatch(deleteCreditExperianHistory());
      }
      
   }
  }, [saveCreditExperianData, storeData2]);
  useEffect(() => {
    //debugger;
    if (typeof saveCreditExperianData !== "undefined" && saveCreditExperianData !== null) {
      if (saveCreditExperianData.success == 1) {
        $('#verifyOtp').attr("disabled", "disabled");
        modalShowHide('otpPopup', 'show');
        handleStart();
        handleSkip();
        $('.otpMsg').html(saveCreditExperianData.otpMsg);
        dispatch(deleteOTPExperianDetails());
      }  
   }
  }, [saveCreditExperianData, storeData2]);

    useEffect(() => {
    let counter;
    if (toggle) {
      counter = setInterval(() => {
        if (timer > 0) {
          setTimer(timer => timer - 1);
        } else {
          setTimer(0);
          clearInterval(counter);
          setToggle(false);
        }
      }, 1000);
    }
    
  }, [toggle]);

  const handleStart = () => {
    setTimer(40);
    //setSkiptimer(10);
    setToggle(true);
    setErrorData((prevState) => ({
      ...prevState,
      ['otp']: false,
    }));
  };

  const handleSkip = () => {
    setSkiptimer(10);
    let counter1;
    counter1 = setInterval(() => {
        if (skiptimer > 0) {
          setSkiptimer(skiptimer => skiptimer - 1);
        } else {
          setSkiptimer(0);
          clearInterval(counter1);
        }
      }, 10000);
  };

  const [data,setData]=useState([]);
  const [cityName,setCityName]=useState();
  const [stateName,setStateName]=useState();

  const storePincodeData = useSelector((state) => state.getCityState);
  const { getCityStateData, loading, error } = storePincodeData;

  useEffect(() => {
    if (typeof getCityStateData?.data !== "undefined" && getCityStateData?.data !== null) {
      let updatedOtherDetails = _.cloneDeep(creditData);
      updatedOtherDetails['city'].field_value = getCityStateData.data.city_name;
      setErrorData((prevState) => ({
        ...prevState,
        ['city']: false,
      }));
      updatedOtherDetails['state'].field_value = getCityStateData.data.state_name;
      setErrorData((prevState) => ({
        ...prevState,
        ['state']: false,
      }));
      setCreditHistoryData(updatedOtherDetails);
      dispatch(deletePincodeDetails());
    }
  }, [getCityStateData, storePincodeData]);

  
  // useEffect(() => {
  //   if (typeof otpMatchExperianData !== "undefined" && otpMatchExperianData !== null) {
  //     console.log(otpMatchExperianData);
  //     if (otpMatchExperianData.success == 1) {
  //       setCreditHistoryCompleted(true);
  //       modalShowHide('otpPopup', 'hide');
  //       modalShowHide('thankyou', 'show');
  //       dispatch(deleteMatchOTPDetails());
  //     }  
  //   }
  // }, [otpMatchExperianData, storeOtpMatch]);

 const otp1 = useRef();
  const otp2 = useRef();
  const otp3 = useRef();
  const otp4 = useRef();
  const otp5 = useRef();
  const otp6 = useRef();
  const captcha = useRef();

  const [otpVal1, setOtpVal1] = useState();
  const [otpVal2, setOtpVal2] = useState();
  const [otpVal3, setOtpVal3] = useState();
  const [otpVal4, setOtpVal4] = useState();
   const [otpVal5, setOtpVal5] = useState();
   const [otpVal6, setOtpVal6] = useState();

  //Handling Initial States Floating Labels
  const [formData, setFormData] = useState({
    nameAsPerBank: null,
    dob: null,
    email: null,
    mobile: null,
    houseNumber: null,
    colony: null,
    pinCode: null,
    city: null,
    state: null,
    documentType: null,
  });

  const modalShowHide = (id, val) => {
    if (val == 'show') {
      setOtpVal1('');
      setOtpVal2('');
      setOtpVal3('');
      setOtpVal4('');
      setOtpVal5('');
      setOtpVal6('');
      $("#" + id).removeClass('hide');
      $("#" + id).addClass('show');
      var eleman2 = document.getElementById('checkboxOtp');
      eleman2?.removeAttribute("disabled");
      var eleman11 = document.getElementById('verifyOtp');
      eleman11?.setAttribute("disabled", "disabled");
      $("#checkboxOtp").prop('checked', false); 
      if (skiptimer < 0 ) {
        setSkipDisabled('disabled');
        var eleman12 = document.getElementById('verifySkip');
        eleman12?.setAttribute("disabled", "disabled");
        var eleman21 = document.getElementById('checkboxSkip');
        eleman21?.removeAttribute("disabled");
        $("#checkboxSkip").prop('checked', false); 
      }
      
    } else {
      $("#" + id).removeClass('show');
      $("#" + id).addClass('hide');
      setOtpVal1('');
      setOtpVal2('');
      setOtpVal3('');
      setOtpVal4('');
      setOtpVal5('');
      setOtpVal6('');
    }
    };


  //Handling Floating Labels
  const handleFloatingLabels = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const saveDate = (id, val) => {
    console.log(id);
    let updatedOtherDetails = _.cloneDeep(creditData);
      updatedOtherDetails[id].field_value = val;
      setCreditHistoryData(updatedOtherDetails);
  };
  const handleInputChange = (e) => {
    let updatedOtherDetails = _.cloneDeep(creditData);
    if (e.target.name == 'pin_code') 
    {
      if (validatePincode(e.target.value)) {
         dispatch(getPincode(e.target.value));
         setErrorData((prevState) => ({
        ...prevState,
        ['pin_code']: false,
      }));
      } else {
        updatedOtherDetails['city'].field_value = '';
        updatedOtherDetails['state'].field_value = '';
           setErrorData((prevState) => ({
        ...prevState,
        ['pin_code']: true,
      }));
      }
    } else if (e.target.name == 'mobile_no') {
      if (validateMobileNumber(e.target.value)) {
         setErrorData((prevState) => ({
        ...prevState,
        ['mobile_no']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['mobile_no']: true,
      }));
      }
    } else if (e.target.name == 'email_address') {
      if (validateEmail(e.target.value)) {
         setErrorData((prevState) => ({
        ...prevState,
        ['email_address']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['email_address']: true,
      }));
      }
    } else if (e.target.name == 'pan_card_number') {
      if (validatePAN(e.target.value)) {
         setErrorData((prevState) => ({
        ...prevState,
        ['pan_card_number']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['pan_card_number']: true,
      }));
      }
    } else if (e.target.name == 'address') { // IB-6018
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['address']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['address']: true,
      }));
      }
    } else if (e.target.name == 'city') {
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['city']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['city']: true,
      }));
      }
    } else if (e.target.name == 'state') {
      if (e.target.value != '') {
         setErrorData((prevState) => ({
        ...prevState,
        ['state']: false,
      }));
      } else {
           setErrorData((prevState) => ({
        ...prevState,
        ['state']: true,
      }));
      }
    }
    updatedOtherDetails[e.target.name].field_value = e.target.value;
    setCreditHistoryData(updatedOtherDetails);
    /*if (e.target.name == 'mobile_no' && !validateNumeric(e.target.value)) {
       updatedOtherDetails[e.target.name].field_value = '';
       setCreditHistoryData(updatedOtherDetails);
    }*/
  };

  const saveCreditExperianDetails = async (e, action) => {
    e.preventDefault();
    let hasError = false;
    
    // debugger;
      Object.entries(
        creditData
      ).map(([key, val]) => {
      if (
        val.is_mandatory == 1 &&
        (val.field_value =="" ||
          val.field_value == null)
      ) {
        hasError = true;
        setErrorData((prevState) => ({
          ...prevState,
          [key]: true,
        }));
      } else {
        if (key == 'email_address' || key == 'mobile_no' || key == 'pin_code' || key == 'pan_card_number') {
          if (key == 'email_address' && !validateEmail(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['email_address']: true,
            }));
          } if (key == 'mobile_no' && !validateMobileNumber(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['mobile_no']: true,
            }));
          } if (key == 'pin_code' && !validatePincode(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['pin_code']: true,
            }));
          } if (key == 'pan_card_number' && !validatePAN(val.field_value)) {
            hasError = true;
            setErrorData((prevState) => ({
              ...prevState,
              ['pan_card_number']: true,
            }));
          }
        } else {
          setErrorData((prevState) => ({
            ...prevState,
            [key]: false,
          }));
        }  
      }
    })
    //console.log(errorData);
    if (hasError == true) {
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
      return;
    } else {
      const formData = getFormData();
      formData['type'] = action;
      console.log(formData);
      dispatch(sendOTPExperianHistory(formData,saveAgainCallback));
    }
    // if(companyId=='1000'&&creditBureau=='Equafix'){
    //   setShowProfilePreview(1)
    // }
  };   
  
  const saveAgainCallback = (payload,resp) => {
    if(resp && resp?.msg){
      if(resp?.msg == 'We are unable to deliver your report through this channel due to a very large number of accounts.'){
        payload.type = 'SKIP_CREDIT_OTP'
        // toast.error("Something went wrong" , {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });     
        dispatch(sendOTPExperianHistory(payload));
        setCreditHistoryCompleted(true);
      }
      if(resp?.msg == 'Question send successfully.' && (resp?.data?.qid == null || resp?.data?.question == null)){
        payload.type = 'SKIP_CREDIT_OTP'
        // toast.error("Something went wrong" , {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
        dispatch(sendOTPExperianHistory(payload));
      }
    }
  }

  const getFormData = () => {
    const formData = {};
    Object.entries(
        creditData
      ).map(([key, val]) => {
        if (val.field_value != null && val.field_value != "") {
          formData[key] = val.field_value;
        }
      })
    return formData;
  };  
//console.log(formData);
const handleOtpInputs = (e) => {
    
    if(e.target.name=="otp1"){
      setOtpVal1((v) => (e.target.validity.valid ? e.target.value : ''))
      
      e.target.focus();
    }
    if(e.target.name=="otp2"){
      setOtpVal2((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp3"){
      setOtpVal3((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp4"){
      setOtpVal4((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp5"){
      setOtpVal5((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    if(e.target.name=="otp6"){
      setOtpVal6((v) => (e.target.validity.valid ? e.target.value : ''))
      
    }
    const finalOtp1 =
      otp1.current.value +
      otp2.current.value +
      otp3.current.value +
      otp4.current.value +
      otp5.current.value +
      otp6.current.value;
    if (finalOtp1.length == 6) {
        setErrorData((prevState) => ({
          ...prevState,
          ['otp']: false,
        }));
    } else {
      setErrorData((prevState) => ({
          ...prevState,
          ['otp']: true,
        }));
    }
    let currentInput = e.target;
    if(e.target.validity.valid==false){
      e.target.focus();
    }
else{
    if(currentInput.value){
    if (currentInput.nextElementSibling !== null) {
      currentInput?.nextElementSibling.focus();
    }
  }
  if(!currentInput.value){
    currentInput?.previousElementSibling?.focus();
  }
}
  };
  const handleCheckbox = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    if (checkid == 'credit_instruction_consent' && checked == true) {
      setFlag(1);
    } else {
      setFlag(0);
    }
    };

    const handleCheckboxOtp = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    if (checkid == 'checkboxOtp' && checked == true) {
      var eleman = document.getElementById('verifyOtp');
      eleman?.removeAttribute("disabled");
      var eleman14 = document.getElementById("checkboxSkip");
      if (eleman14 !== null) {
        // Element exists, safe to perform operations
        eleman14?.setAttribute("disabled", "disabled");
      }
      var elema = document.getElementById('verifySkip');
      elema?.setAttribute("disabled", "disabled");
    } else {
      var eleman = document.getElementById('verifyOtp');
      eleman?.setAttribute("disabled", "disabled");
      var eleman13 = document.getElementById('checkboxSkip');
      eleman13?.removeAttribute("disabled");
      /*var eleman15 = document.getElementById('checkboxOtp');
      eleman15.setAttribute("disabled", "disabled");*/
    }
    };

    const handleCheckboxSkip = (e) => {
    let checkid = e.target.id;
    let checked = e.target.checked;
    if (checkid == 'checkboxSkip' && checked == true) {
      var eleman = document.getElementById('verifySkip');
      eleman?.removeAttribute("disabled");
      var eleman11 = document.getElementById('checkboxOtp');
      eleman11?.setAttribute("disabled", "disabled");
      var elema = document.getElementById('verifyOtp');
      elema?.setAttribute("disabled", "disabled");
      setSkipDisabled(false);
      $("#checkboxOtp").prop('checked', false);
    } else {
      var eleman = document.getElementById('verifySkip');
      eleman?.setAttribute("disabled", "disabled");
      var eleman12 = document.getElementById('checkboxOtp');
      eleman12?.removeAttribute("disabled");
      /*var eleman15 = document.getElementById('checkboxSkip');
      eleman15.setAttribute("disabled", "disabled");*/
    }
    };

    const handleConsent = (e, url) => {
      setConsentFlag(1);
      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));
      userLocalData.consent_complete = 1;
      console.log(url);
      localStorage.setItem('userVerificationCandidate', JSON.stringify(userLocalData));
      navigate(url);
    }; 

  const verifyOtpHandler = async (e) => {
    e.preventDefault();
    const finalOtp =
      otp1.current.value +
      otp2.current.value +
      otp3.current.value +
      otp4.current.value +
      otp5.current.value +
      otp6.current.value;
      if (finalOtp == '') {
        setErrorData((prevState) => ({
              ...prevState,
              ['otp']: true,
            }));
      } else {
        if (finalOtp.length != 6) {
            setErrorData((prevState) => ({
              ...prevState,
              ['otp']: true,
            }));
        } else {
         dispatch(validateExperianOtp({type: "VERIFY_CREDIT_OTP",
         mobile_otp: finalOtp,}, verifyOTPCallBack));
        }
      }
    // setShowModal3(true)
  };

  const saveCreditExperianUserDetails = async (e) => {
      dispatch(saveExperianHistory());
  };

  const verifyOTPCallBack = (result, payload) => {
    if(result?.success == 1) {
      modalShowHide('otpPopup', 'hide');
    }
    if(result?.success == 1 && result?.msg == "Phone Validation Failed"){
      setShowModal3(true);
      modalShowHide('otpPopup', 'hide');
      dispatch(deleteMatchOTPDetails());
    }

    else if(result?.success == 1 
      && (result?.msg == "Your credit report has been generated" 
      || result?.msg == "Your credit report does not exist")
      ) {
      handleSuccessOtpValidation();
    }
    // Recalling the api after otp verification in case the experian fails to fetch the report or the questions aren't fetched 
    if(result && result?.msg){
      if(result?.msg == 'We are unable to deliver your report through this channel due to a very large number of accounts.'){
        payload.type = 'SKIP_CREDIT_OTP'
        // toast.error("Something went wrong" , {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });     
        dispatch(validateExperianOtp(payload));
        modalShowHide('otpPopup', 'hide');
        setCreditHistoryCompleted(true);
        
      }
      if(result?.msg == 'Question send successfully.' && (result?.data?.qid == null || result?.data?.question == null)){
        payload.type = 'SKIP_CREDIT_OTP'
        // toast.error("Something went wrong" , {
        //   position: "top-right",
        //   autoClose: 5000,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        // });
        dispatch(validateExperianOtp(payload));
        modalShowHide('otpPopup', 'hide');
      }
    }

  }

  const handleSuccessOtpValidation = () => {
    setCreditHistoryCompleted(true);
        setOtpSentOnMatchFlag(false);
        // modalShowHide('otpPopup', 'hide');
        console.log("consent reached line 783");
        modalShowHide('thankyou', 'show');
        setConsentFlag(1);
        dispatch(deleteMatchOTPDetails());
        // const successOTpSCreen = {
        //   "success": 1,
        //   "type": "VERIFY_CREDIT_OTP2",
        //   "msg": "Your credit report has been generated",
        //   "api": 1,
        //   "CREDIT_BUREAU": "Experian"
        // }
  
      }
   

      // useEffect(() => {
      //   console.log("consent flag...", consentFlag)
      // },[consentFlag])

  const [runRequest, setRunRequest] = useState(0);

  const resetOtpHandler = () => {
    
    let apiCompanyData;

    const runAPi = async () => {

      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate')); 

      const requestData = {
        token: tokenId,
        type : "RESEND_CREDIT_OTP"
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      const { data : result } = await axios.post(FOLDERPATH +
        "/CandidateApi/creditHistory",
        requestData,
        {
          headers,
        }
      );

      if (result.success == "1") {

      const { data } = result;

      const msg = result.msg;

      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    } else {

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }
      // Reset the timer here
      handleStart();

      setCount(count+1);
    };

    runAPi();
  };


  const verifySkipHandler = () => {
    let apiSkipData;

    const runSkipAPi = async () => {

      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate')); 

      const requestData = {
        token: userLocalData.id,
        type : "SKIP_CREDIT_OTP",
      };
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };
      const { data : result } = await axios.post(FOLDERPATH +
        "/CandidateApi/creditHistory",
        requestData,
        {
          headers,
        }
      );

      if (result.success == "1") {

      const { data } = result;

      // const msg = result.msg;

      // toast.success(msg, {
      //   position: "top-right",
      //   autoClose: 5000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   progress: undefined,
      // });

      setCreditHistoryCompleted(true);
      setIsQuestionVisible(false);
      setOtpSentOnMatchFlag(false);
      console.log("consent reached line 1009");
      modalShowHide('thankyou2', 'show');
      setConsentFlag(1);

    } else {

      const msg = result.msg;

      toast.error(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

    }
      // Reset the timer here
      //resetTimer();
      setCreditHistoryCompleted(true);
      modalShowHide('otpPopup', 'hide');
      dispatch(deleteSaveExperianDetails());
      setCount(count+1);
    };

    runSkipAPi();
  };

  const {
    countryCodeOptions,
  } = GetMasterData();
  const optionsKey = {
    country_codes: countryCodeOptions,
  };
  
  const optionsStatic = [{label: {text: "+91", value: 91, 
                        "data-subtext": "India"
                        },
                        value: "0"}];
  const handleCountryCode = (e) => {
    let updatedOtherDetails = _.cloneDeep(creditData);
    updatedOtherDetails['mobile_code'].field_value = e.target.value;
    setCreditHistoryData(updatedOtherDetails);
  };

  const handleSubmitForPreview = (e) => {
    e.preventDefault();
    navigate(`/case-initiation/profile-preview/${reference}`);
  };

  const handleContinueClick = () => {
    setIsVerifyViaPhoneNoVisible(false); // Hide VerifyViaPhoneNo component
    // setIsQuestionVisible(true);
    // credit history flow change questions screen removed from flow
    verifySkipHandler();
  };


  const handleDynamicModalConfirm = () => {
    // Logic for handling confirmation
    console.log("Confirmed");
    // Proceed with further action
    setConsentFlag(false);
    setConsentFlag(2);
    setShowProfilePreview(false);
    setShowProfilePreview(0);
    setShowModal3(false); // Close the modal
    setIsVerifyViaPhoneNoVisible(true); // Show VerifyViaPhoneNo component
  };

  const modalContent3 = {
    head: (
      <div
        style={{
          fontSize: "20px",
          fontWeight: "600",
          lineHeight: "30px",
          textAlign: "center",
          paddingTop: "20px"
        }}
      >
        Phone validation failed
      </div>
    ),
    body: "content",
    content: (
      <>
        Try using other phone number(s) linked <br /> with your bank/credit
        card.
      </>
    ),
    footer: "Continue",
    showCancel: false, // Render "Cancel" button
    icon: modalContent3Icon, // Icon/image URL for modal 3
  };

  const handleLastQuesSubmitExperian  = (result) => {
    if(result?.success == 0) {
      setIsQuestionVisible(false);
      setDetailsNotfoundFlag(true);
    } else if(result?.success == 1 && (!result?.data || result?.msg === "Your credit report has been generated")){
      setCreditHistoryCompleted(true);
      setIsQuestionVisible(false);
      setOtpSentOnMatchFlag(false);
      console.log("consent reached line 1009");
      modalShowHide('thankyou', 'show');
      setConsentFlag(1);
    }
  }

  const handleNoQuestionFetched  = (result) => {
    if(result?.success == 0) {
      setIsQuestionVisible(false);
      setDetailsNotfoundFlag(true);
    } else if(result?.success == 1 && (result?.msg === "Questions" && result?.data?.qid == null || result?.data?.question == null)){
      setCreditHistoryCompleted(true);
      setIsQuestionVisible(false);
      setOtpSentOnMatchFlag(false);
      console.log("consent reached line 1009");
      // modalShowHide('thankyou', 'show');
      setConsentFlag(1);
    }
  }

  const handleOnMatchAltNumber = (altNumber) => {
    setIsVerifyViaPhoneNoVisible(false);
    setOtpSentOnMatchFlag(true);
    setSelectedAltNumber(altNumber);
  }  

  const handleDetailsNotFoundFlow = () => {
    setDetailsNotfoundFlag(false);
    // setIsVerifyViaPhoneNoVisible(false);
    setCreditHistoryCompleted(true);
    // setIsQuestionVisible(false);
    // setOtpSentOnMatchFlag(false);
    setConsentFlag(1);
    // saveCreditExperianUserDetails();
  }

  useEffect(() => {
    return () => {
        deleteCreditExperianHistory();
        deleteMatchOTPDetails();
        deleteOTPExperianDetails();
        deleteSaveExperianDetails();
    }
}, [])
    
  return (
    <>
    {isLoading && <Loader />} 
      <NotificationPanels />
      {role=="EP"? <ClientHeader />:<Header/>}
      {role=="EP"? <ClientSideBar /> :<Sidebar/>}
      {/* <Header />
      <Sidebar /> */}
      <section
        className="main-section candidate-tab-form"
        style={{ paddingTop: "60px" }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-auto bg-gray-mbl">
              <ProgressHeading/>
              <CandidateTab activeTab={"Credit History"} />
            </div>
            <div className="col bg-gray-mbl">
              {/*Form*/}

              <form
                ref={form}
                className="p-3 form2 form-section"
                style={{ minHeight: "700px" }}
              >
                <StepCount activeTab={"Credit History"}/>
                <h2 className="fnt-smi-bld">Credit History</h2>
                <p className="text-muted">
                  We will be obtaining your Credit Information Report from one of the credit bureau as part of the process. Please provide the following information for the same.
                  Kindly ensure that the mobile number and email address entered here must be associated with your bank and credit cards.
                </p>
                <hr />
                {consentFlag == 0 && consentFlag == '' &&
                <div className="d-block">
                <h6 className="fnt-smi-bld mt-3">Instructions</h6>
                <p className="text-muted">Kindly note that our Credit Bureau Partner {IsEquafixEnabled=='1'&& creditBureau=='Equafix'? '(Equafix)' : '(Experian/CIBIL)'} will release your Password Protected Credit Information Report (CIR) using the information provided by you. Step by step methodology of this process has been listed below for your reference.</p>

                <h6 className="fnt-smi-bld mt-3">How it works</h6>
                {IsEquafixEnabled=='1'&& creditBureau=='Equafix'? (<p className="text-muted"><span className="fnt-smi-bld text-dark">Step 1 :</span> You will be required to enter the E-mail Address and Mobile Number associated with your bank on the next page (Credit History form). </p>) : (<p className="text-muted"><span className="fnt-smi-bld text-dark">Step 1 :</span> You will be required to enter the E-mail Address and Mobile Number associated with your bank on the next page (Credit History form). You will receive an OTP on the entered Mobile Number. This 6-digit OTP needs to be entered to proceed further.</p>)}
                {IsEquafixEnabled=='1'&& creditBureau=='Equafix'? '' : (<p className="text-muted"><span className="fnt-smi-bld text-dark">Step 2 :</span> As per RBI guideline, a copy of your credit report (password protected) will be sent to the E-mail ID provided by you on the credit history page. This report will have a detailed analysis of your credit history.</p>)}

                <p className="text-muted">Note – AuthBridge will Only consume the address history details from the credit bureau report for address verification purposes.</p>

                <p className="text-muted"><span className="fnt-smi-bld text-dark">Step {IsEquafixEnabled=='1'&& creditBureau=='Equafix'? '2' : '3' } :</span> AuthBridge would extract the addresses history from the Credit Bureau Report only for the purpose of Address Verification. Post that, the Credit Report will be deleted from the system automatically and will no longer be available to any individual in AuthBridge or {companyName}.</p>

                <p className="text-muted">Note - Address history extraction process is automated and has no human intervention.</p>

                <div className="form-check mt-3">
                  <input type="checkbox" className="form-check-input" id="credit_instruction_consent" onChange={(e) => handleCheckbox(e)} />
                  <label htmlFor="credit_instruction_consent" className="form-check-label fnt-smi-bld">By clicking I read & accept, here by I: <sup className="text-danger">*</sup></label>
                </div>

                <p className="text-muted">Understand the above process and agree that the generated credit report will only be used to verify my Address History provided in this form. This is a required field.</p>

                <div className="row mt-3">
                  <div className="col-md-3">
                    {flag == 0 && flag == ''? ( 
                        <Link to='#' className="text-primary no-effect-link">
                      <button type = 'button'className="btn btn-primary btn-md btn-block mt-3" disabled id="credit_instruction_consent_save" onClick={(e) => handleConsent(e, url)}>
                      Proceed
                      </button>
                     </Link>
                        ) : ( 
                       <Link to='#' className="text-primary no-effect-link">
                      <button type = 'button'className="btn btn-primary btn-md btn-block mt-3" id="credit_instruction_consent_save" onClick={(e) => handleConsent(e, url)}>
                      Proceed
                      </button>
                     </Link>
                        )}                    

                  </div>
                </div>
                </div>    
                }
                {consentFlag == 1 &&
                  <>
                <div className="row">
                  {creditData.first_name ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.first_name.input_type
                    }
                    inputName={`first_name`}
                    inputValue={
                      creditData.first_name.field_value
                    }
                    isInputMandatory={
                      creditData.first_name.is_mandatory
                    }
                    inputLabel={
                      creditData.first_name.label
                    }
                    readOnly={IsEquafixEnabled=='1'?false:true}
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`first_name`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.middle_name ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.middle_name.input_type
                    }
                    inputName={`middle_name`}
                    index={`email_id`}
                    readOnly={IsEquafixEnabled=='1'?false:true}
                    inputValue={
                      creditData.middle_name.field_value
                    }
                    isInputMandatory={
                      creditData.middle_name.is_mandatory
                    }
                    inputLabel={
                      creditData.middle_name.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`middle_name`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.last_name ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.last_name.input_type
                    }
                    inputName={`last_name`}
                    index={`email_id`}
                    inputValue={
                      creditData.last_name.field_value
                    }
                    isInputMandatory={
                      creditData.last_name.is_mandatory
                    }
                    readOnly={IsEquafixEnabled=='1'?false:true}
                    inputLabel={
                      creditData.last_name.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`last_name`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.email_address ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.email_address.input_type
                    }
                    inputName={`email_address`}
                    index={`email_address`}
                    inputValue={
                      creditData.email_address.field_value
                    }
                    readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    isInputMandatory={
                      creditData.email_address.is_mandatory
                    }
                    inputLabel={
                      creditData.email_address.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`email_address`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.email_address.field_value != '' ? 'Please Enter a valid Email id.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.date_of_birth ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      'date'
                    }
                    inputName={`date_of_birth1`}
                    index={`date_of_birth`}
                    inputValue={
                      creditData.date_of_birth.field_value
                    }
                    saveDate={saveDate}
                    showDate={creditData.date_of_birth.field_value}
                    isInputMandatory={
                      creditData.date_of_birth.is_mandatory
                    }
                    readOnly={IsEquafixEnabled=='1'?false:true}
                    inputLabel={
                      creditData.date_of_birth.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`date_of_birth`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.mobile_no ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.mobile_no.input_type
                    }
                    inputName={`mobile_no`}
                    index={`mobile_no`}
                    inputValue={
                      creditData.mobile_no.field_value
                    }
                    readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    isInputMandatory={
                      creditData.mobile_no.is_mandatory
                    }
                    countryCodeValue = {creditData.mobile_code.field_value}
                    handleCountryCode={(e) =>
                      handleCountryCode(e)
                    }
                    options={
                      optionsStatic
                        
                    }
                    inputLabel={
                      creditData.mobile_no.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`mobile_no`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.mobile_no.field_value != '' ? 'Please Enter a valid mobile no.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.gender ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.gender.input_type
                    }
                    inputName={`gender`}
                    index={`gender`}
                    inputValue={
                      creditData.gender.field_value
                    }
                    disabled={IsEquafixEnabled=='1'?false:true}
                    options={
                      gender
                      ? gender
                      : []
                    }
                    isInputMandatory={
                      creditData.gender.is_mandatory
                    }
                    inputLabel={
                      creditData.gender.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`gender`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.pan_card_number ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.pan_card_number.input_type
                    }
                    inputName={`pan_card_number`}
                    inputValue={
                      creditData.pan_card_number.field_value
                    }
                    readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    index={`pan_card_number`}
                    isInputMandatory={
                      creditData.pan_card_number.is_mandatory
                    }
                    inputLabel={
                      creditData.pan_card_number.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`pan_card_number`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.pan_card_number.field_value != '' ? 'Please enter a valid PAN Number.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.address ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.address.input_type
                    }
                    inputName={`address`}
                    inputValue={
                      creditData.address.field_value
                    }
                    readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    isInputMandatory={
                      creditData.address.is_mandatory
                    }
                    index={`address`}
                    inputLabel={
                      creditData.address.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`address`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.pin_code ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      creditData.pin_code.input_type
                    }
                    inputName={`pin_code`}
                    inputValue={
                      creditData.pin_code.field_value
                    }
                    readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    index={`pin_code`}
                    isInputMandatory={
                      creditData.pin_code.is_mandatory
                    }
                    inputLabel={
                      creditData.pin_code.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`pin_code`
                      ] == true ? ( 
                        <p className="text-danger">
                        {creditData.pin_code.field_value != '' ? 'Please Enter a valid Pin Code.' : 'This field is required.'}
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>

                <div className="row">
                  {creditData.city ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      1
                    }
                    inputName={`city`}
                    inputValue={
                      creditData.city.field_value
                    }
                    index={`city`}
                    isInputMandatory={
                      creditData.city.is_mandatory
                    }
                    readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    inputLabel={
                      creditData.city.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`city`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                  {creditData.state ? 
                    <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                    <InputField
                    inputType={
                      1
                    }
                    inputName={`state`}
                    inputValue={
                      creditData.state.field_value
                    }
                    index={`state`}
                    isInputMandatory={
                      creditData.state.is_mandatory
                    }
                    // readOnly = {IsEquafixEnabled=='1'?false:CreditHistoryCompleted ? true : false}
                    readOnly={true}
                    inputLabel={
                      creditData.state.label
                    }
                    handleOnChange={handleInputChange}
                    />
                    {errorData[`state`
                      ] == true ? ( 
                        <p className="text-danger">
                        This field is required.
                        </p>
                        ) : ''}
                      </div>
                      </div>
                      : <></>
                    }
                </div>
                {/*<h6 className="fnt-smi-bld mb-0">Upload File</h6>

                <small className="text-muted">
                  upload one of following : Electricity Bill, Phone Bill, Voter
                  ID , Adhaar Card
                </small>
                <div className="row mt-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="form-group">
                      <div className="floating-label">
                        <select
                          name="documentType"
                          id="documentType"
                          className="form-control"
                          onChange={handleFloatingLabels}
                        >
                          <option value=""></option>
                          <option value="d">d</option>
                        </select>
                        <label
                          htmlFor="batchEnd"
                          className={formData.documentType && "focused"}
                        >
                          Select Document Type
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="upload-box">
                      <div className="left d-flex align-items-center">
                        <img
                          src={TickIconBlack}
                          className="mr-2 pl-3 pr-3"
                          alt=""
                        />
                        <span>
                          <h6 className="m-0">Document uploaded</h6>
                          <small className="text-muted">6 Files uploaded</small>
                        </span>
                      </div>
                      <div className="right text-right">
                        <img src={CrossIcon} alt="" className="remove-btn" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-3">
                  <div className="col-sm-4 col-md-12 col-xl-4">
                    <div className="upload-box">
                      <div className="left d-flex align-items-center">
                        <img src={UploadIcon} className="mr-2" alt="" />
                        <span>
                          <h6 className="m-0">Credit History</h6>
                          <small className="text-muted">
                            upload degree certificate
                          </small>
                        </span>
                      </div>
                      <div className="right text-right">
                        <img
                          src={ArrowRightIcon}
                          alt=""
                          className="remove-btn"
                        />
                      </div>
                    </div>
                  </div>
                </div>*/}

                <div className="row mt-3">
                  {IsEquafixEnabled=='1'&&creditBureau=='Equafix'?<div className="col-auto d-flex justify-content-between">
                    {/*<button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Back
                    </button>*/}
                     
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3 mr-2"  id = "SendOTP" onClick={(e) => saveCreditExperianDetails(e, 'SUBMIT_CREDIT_DATA')}>
                      Save
                    </button>
                        
                    
                    {/*<button type="button" className="btn btn-primary btn-lg btn-block mt-3"  id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>*/}
                  </div>
                  :<div className="col-auto d-flex justify-content-between">
                    {/*<button className="btn btn-outline-secondary btn-lg btn-block mt-3 mr-2">
                      Back
                    </button>*/}
                    {CreditHistoryCompleted == true ? ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3 mr-2" disabled id = "SendOTP" onClick={(e) => saveCreditExperianDetails(e, 'SUBMIT_CREDIT_DATA')}>
                      Submit
                    </button>
                        ) : ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3 mr-2" id = "SendOTP" onClick={(e) => saveCreditExperianDetails(e, 'SUBMIT_CREDIT_DATA')}>
                      Submit
                    </button>
                        )}
                    {CreditHistoryCompleted == true ? ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3"  id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>
                        ) : ( 
                        <button type="button" className="btn btn-primary btn-lg btn-block mt-3" disabled id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>
                        )}
                    {/*<button type="button" className="btn btn-primary btn-lg btn-block mt-3"  id = "isContinue" onClick={(e) => saveCreditExperianUserDetails(e)}>
                      Continue
                    </button>*/}
                  </div>}
                </div>
                </>
              }
              {showProfilePreview == 1 && (
                    <div className="row">
                      <div className="col-auto d-flex justify-content-between">
                        <button
                          className="btn btn-primary btn-lg btn-block mt-3"
                          onClick={(e) => handleSubmitForPreview(e)}
                        >
                          {clientId == 459831 ? "Preview" : "Submit for Preview"}
                        </button>
                      </div>
                      <div className="col-auto d-flex justify-content-between mt-4">
                        <small className="text-muted">
                          Please complete all the mandatory fields before final
                          submission
                        </small>
                      </div>
                    </div>
                )}
                
                {isVerifyViaPhoneNoVisible && (
                    <VerifyViaPhoneNo onContinueClick={handleContinueClick} handleOnMatchAltNumber={handleOnMatchAltNumber}/>
                )}
                {isQuestionVisible && (
                    <AnsBelowQues handleLastQuesSubmitExperian = {handleLastQuesSubmitExperian} handleNoQuestionFetched={handleNoQuestionFetched}/>
                )}
                {
                  detailsNotfoundFlag && (
                    <DetailsNotFound handleDetailsNotFoundFlow = {handleDetailsNotFoundFlow}/>
                  )
                }
                {
                  otpSentOnMatchFlag && (
                  <VerifyViaOTP selectedOption={selectedAltNumber} handleSuccessOtpValidation = {handleSuccessOtpValidation}/> 
                  )
                }
              </form>

              {/*Form*/}
              {/*<div className="mt-4">
                <div className="row mb-3">
                  <div className="col-md-12 d-flex align-items-center btn-and-info-responsive">
                    <button className="btn btn-primary btn-lg mr-3">
                      Submit for Preview
                    </button>
                    <span className="text-muted">
                      Please complete the all mandatory fields before final
                      submission
                    </span>
                  </div>
                </div>
              </div>*/}
              <Footer />
            </div>
          </div>
        </div>
      </section>
      <div className="dashboard custom-modal-dialog" id="otpPopup">
        <div className="modal-wrapper">
        <div className="modal-content p-4 no-scroll credit_modal" >
          <span className="cstm-popup-close-btn" onClick={(e) => modalShowHide('otpPopup', 'hide')}>
              &times;
            </span>
            <center>
              <img src={MobileIcon} width="50" alt=""/>
            </center>
            <form ref={form} className="d-flex">
              <div className="m-4 form justify-content-between w-100">
                <h4 className="fnt-bld text-center">Please enter OTP</h4>
                <p
                  className="fnt-sml-md text-center otpMsg"
                  style={{ color: "#667085" }}
                >
                  The One Time Password is sent to Mobile Number 12345*****. <br/>Please enter the one time password.
                </p>
                <div className="">
                  <div className="otp-inputs d-flex justify-content-center">
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      ref={otp1}
                      autoComplete="off"
                      name="otp1"
                      pattern="[0-9]*"
                      value={otpVal1}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp2"
                      autoComplete="off"
                      ref={otp2}
                      pattern="[0-9]*"
                      value={otpVal2}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp3"
                      autoComplete="off"
                      ref={otp3}
                      pattern="[0-9]*"
                      value={otpVal3}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp4"
                      autoComplete="off"
                      ref={otp4}
                      pattern="[0-9]*"
                      value={otpVal4}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp5"
                      autoComplete="off"
                      ref={otp5}
                      pattern="[0-9]*"
                      value={otpVal5}
                      onChange={handleOtpInputs}
                    />
                    <input
                      type="text"
                      className="form-control fnt-bld"
                      maxLength="1"
                      name="otp6"
                      autoComplete="off"
                      ref={otp6}
                      pattern="[0-9]*"
                      value={otpVal6}
                      onChange={handleOtpInputs}
                    />
                  </div>
                  {errorData[`otp`
                      ] == true ? ( 
                        <center className="ml-8 text-danger fnt-sml-md">
                        Please enter a valid OTP.
                        </center>
                        ) : ''}
                </div>
                <div className="text-center fnt-sml" style={{marginTop:"5px"}}>
                    <span className="text-muted">Didn’t get a code? </span>
                      { timer > 0 ? ( 
                      <span className="text-muted">
                        
                        Resend OTP in {timer} Seconds{" "}
                      </span>):<>{ count==5 ? ( <span className="text-muted">
                        
                        No more attempts left{" "}
                        </span>):''}</>}
                      {timer < 0 && count<5 ? (
                        <Link
                          to="#"
                          className="text-primary"
                          onClick={resetOtpHandler}
                        >
                          Click to resend
                        </Link>
                      ) : (
                        ""
                      )}
                  </div>
                <div className="form-check mt-3 mb-2">
                {/* {skiptimer < 0 ? ( <>

                  <input type="checkbox" className="form-check-input" id="checkboxSkip" onChange={(e) => handleCheckboxSkip(e)} />
                  <label htmlFor="checkboxSkip" className="form-check-label fnt-smi-bld">I have not received an OTP on my mobile number, I want to proceed to the next step.</label>
                  <br/> </>): ''} */}
                  <input type="checkbox" className="form-check-input" id="checkboxOtp" onChange={(e) => handleCheckboxOtp(e)} />
                  <label htmlFor="checkboxOtp" className="form-check-label fnt-smi-bld">I Agree & accept </label>
                </div>
                <p className="text-muted fnt-sml-md chk_p pr-2">You hereby consent to AUTHBRIDGE being appointed as your authorized representative to receive your Credit Information from Experian for the purpose of background verification. By executing this agreement/consent form, you are expressly agreeing to access the Experian Credit Information Report and credit score, aggregate scores, inferences, references and details (as defined below) (together referred as 'credit information').You hereby also irrevocably and unconditionally consent to such credit information being provided by Experian to you and AUTHBRIDGE by using experian tools, algorithms and devices and you hereby agree, acknowledge and accept the TERMS & CONDITIONS set forth herein <a href={consentUrl} target = "_blank" download="Terms and Conditions">Terms and conditions</a>.</p>

                <div className="row ">
                  <div className="col-md-12 d-flex justify-content-between crd_btn">
                  {/* {skiptimer < 0 ? (
                    <button type="button"  className="btn btn-primary btn-lg btn-block mt-3 mr-2 " id="verifySkip" disabled ={skipDisabled} onClick={(e) => verifySkipHandler(e)}>Continue</button>
                    ): ''} */}
                    <button type="button" className="btn btn-primary btn-lg btn-block mt-3" id="verifyOtp"  onClick={(e) => verifyOtpHandler(e)}>Verify OTP</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="dashboard custom-modal-dialog" id="thankyou">
        <div className="modal-wrapper justify-content-center" style={{maxWidth:'300px'}}>
          <div className="modal-content p-4 no-scroll">
            <center>
              <img src={MobileIcon} width="50" alt=""/>
              <h6 className="fnt-smi-bld mt-3 mb-3">Thank You!</h6>
              <p className="text-muted thankmsg" >You will receive a copy of your credit information report directly also from the credit bureau on your registered email id for your records.</p>
            </center>
            <div className="row mt-3">
              <div className="col-md-12 d-flex justify-content-between">
                <button className="btn btn-primary btn-lg btn-block" onClick={(e) => modalShowHide('thankyou', 'hide')}>close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard custom-modal-dialog" id="thankyou2">
        <div className="modal-wrapper justify-content-center" style={{maxWidth:'300px'}}>
          <div className="modal-content p-4 no-scroll">
            <center>
              <img src={MobileIcon} width="50" alt=""/>
              <h6 className="fnt-smi-bld mt-3 mb-3">Thank You!</h6>
              {/* <p className="text-muted thankmsg" >You will receive a copy of your credit information report directly also from the credit bureau on your registered email id for your records.</p> */}
            </center>
            <div className="row mt-3">
              <div className="col-md-12 d-flex justify-content-between">
                <button className="btn btn-primary btn-lg btn-block" onClick={(e) => modalShowHide('thankyou2', 'hide')}>close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DynamicModal
        show={showModal3}
        onHide={() => setShowModal3(false)}
        modalContent={modalContent3}
        onConfirm={handleDynamicModalConfirm}
      />
    </>
  );
};
export default CandidateCreditExperianHistory;